var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"con"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.parameter.ksmc)+"科室")]),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.parameter.REMARK))]),_c('div',{staticClass:"depart-footer",on:{"click":_vm.registeredBtn}},[_vm._v("去挂号")])])
}
var staticRenderFns = []

export { render, staticRenderFns }